// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import ToastPropsDefault, { toasterProps as toasterPropsDefault } from "@insite/mobius/Toast/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import AlertError from "@sc/XDL/Icons/AlertError";
import AlertInfo from "@sc/XDL/Icons/AlertInfo";
import AlertSuccess from "@sc/XDL/Icons/AlertSuccess";
import AlertWarning from "@sc/XDL/Icons/AlertWarning";
import Close from "@sc/XDL/Icons/Close";
import { buttonTransparent } from "@sc/XDL/PreStyle/button";
import { xBaseTheme } from "@sc/XDL/types";
import { color } from "@sc/XDL/Utilities";
import { css, ThemeProps } from "styled-components";

export default {
    defaultProps: {
        ...ToastPropsDefault,
        mergeCss: true,
        closeButtonProps: {
            mergeCss: true,
            color: "transparent",
            buttonType: "solid",
            shape: "pill",
            css: css`
                position: absolute;
                top: 0;
                right: 0;
                border: 0;
                width: 28px;
                height: 28px;
                padding: 12px 12px 0 0;
                ${buttonTransparent}
                &:hover ${IconWrapper} {
                    color: ${color("common.ui8")};
                }
            `,
        },
        closeButtonIconProps: {
            mergeCss: true,
            src: "X",
            size: 16,
            color: "common.ui4",
        },
        iconProps: {
            mergeCss: true,
            size: 18,
            css: css`
                margin-top: 2px;
                margin-right: 12px;
            `,
        },
        iconSrcByMessage: {
            success: AlertSuccess,
            warning: AlertWarning,
            danger: AlertError,
            info: AlertInfo,
        },
        bodyTypographyProps: {
            mergeCss: true,
            css: css`
                &,
                & ${TypographyStyle}, & > div > ${TypographyStyle} {
                    font-size: 14px;
                    line-height: 22px;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            `,
            color: "text.main",
        },
        cssOverrides: {
            toast: css`
                border-style: solid;
                border-width: 1px;
                background: ${({ messageType }: any) => color(`${messageType}.light`)};
                border-radius: 4px;
            `,
            toastBody: css`
                &&& {
                    margin: 0;
                }
                align-items: flex-start;
                padding: 9px 30px 9px 12px;
            `,
        },
    },
    toasterProps: {
        ...toasterPropsDefault,
    },
} as xBaseTheme["toast"];
